import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { forwardRef, useContext } from 'react';
import cx from 'classnames';
import { prefix } from '../../../tools/settings';
import Button from '../../Button';
import { TakeoverContext } from '../Takeover';
import { Styled } from './Footer.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var useTakeoverContext = function useTakeoverContext() {
  return useContext(TakeoverContext);
};

var Footer = forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      customClassName = _ref.className,
      id = _ref.id;
  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-takeover__footer"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  var _useTakeoverContext = useTakeoverContext(),
      footer = _useTakeoverContext.footer;

  var footerActions = footer === null || footer === void 0 ? void 0 : footer.actions;
  return _jsx(Styled.Footer, {
    ref: ref,
    id: id,
    className: className,
    children: _jsxs(Styled.FooterActions, {
      children: [footerActions && footerActions.map(function (action, index) {
        var _action$iconLeft, _action$iconRight, _action$isDisabled, _action$isLoading, _action$variant;

        return _jsx(Button, {
          iconLeft: (_action$iconLeft = action === null || action === void 0 ? void 0 : action.iconLeft) !== null && _action$iconLeft !== void 0 ? _action$iconLeft : null,
          iconRight: (_action$iconRight = action === null || action === void 0 ? void 0 : action.iconRight) !== null && _action$iconRight !== void 0 ? _action$iconRight : null,
          isDisabled: (_action$isDisabled = action === null || action === void 0 ? void 0 : action.isDisabled) !== null && _action$isDisabled !== void 0 ? _action$isDisabled : false,
          isLoading: (_action$isLoading = action === null || action === void 0 ? void 0 : action.isLoading) !== null && _action$isLoading !== void 0 ? _action$isLoading : false,
          variant: (_action$variant = action === null || action === void 0 ? void 0 : action.variant) !== null && _action$variant !== void 0 ? _action$variant : 'secondary',
          onClick: action.onClick,
          children: action.label
        }, index);
      }), children]
    })
  });
});
export default Footer;